"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var timeout_1 = require("./lib/timeout");
module.exports = timeout_1.Timeout;
//# sourceMappingURL=index.js.map
